uniform vec2 uLightPos;    // 光源（月）の NDC 座標
uniform float uAspect;     // 画面の縦横比（円を真円にする補正）
uniform float uIntensity;  // 0-1。GSAP でフェード
uniform float uVisibility; // 光源が画面外・カメラ後方の時に 0（JS 側で計算）
uniform float uStrength;   // 全体の強さ（debug 調整用）
uniform float uTime;

varying vec2 vUv;

// 柔らかい円盤
float disc(vec2 p, vec2 c, float r, float soft)
{
    return 1.0 - smoothstep(r - soft, r + soft, length(p - c));
}

// 細いリング
float ring(vec2 p, vec2 c, float r, float w)
{
    return 1.0 - smoothstep(0.0, w, abs(length(p - c) - r));
}

/*
 * スクリーンスペースのレンズフレア。
 * 「光源 → 画面中心 → その先」の軸上にゴースト（色付き円盤）とリングを並べる。
 */
void main()
{
    // スクリーン座標（-1〜1、横はアスペクト補正で等方に）
    vec2 p = vUv * 2.0 - 1.0;
    p.x *= uAspect;

    vec2 light = uLightPos;
    light.x *= uAspect;

    // 光源から画面中心を通って反対側へ伸びる軸
    vec2 axis = -light;

    // ごく僅かな脈動
    float pulse = 1.0 + 0.05 * sin(uTime * 1.7);

    vec3 color = vec3(0.0);

    // ゴースト円盤の連なり（青系のバリエーション、控えめに）
    color += vec3(0.55, 0.70, 1.00) * disc(p, light + axis * 0.35, 0.045 * pulse, 0.030) * 0.35;
    color += vec3(0.80, 0.60, 1.00) * disc(p, light + axis * 0.65, 0.090, 0.060) * 0.22;
    color += vec3(0.95, 0.90, 0.75) * disc(p, light + axis * 0.85, 0.018, 0.012) * 0.45;
    color += vec3(0.50, 1.00, 0.90) * disc(p, light + axis * 1.05, 0.030 * pulse, 0.020) * 0.40;
    color += vec3(0.60, 0.80, 1.00) * disc(p, light + axis * 1.45, 0.140, 0.100) * 0.16;

    // 軸の遠くに大きな薄いリング
    color += vec3(0.55, 0.75, 1.00) * ring(p, light + axis * 1.80, 0.40 * pulse, 0.06) * 0.20;

    // 光源まわりの大きく柔らかいベール
    color += vec3(0.75, 0.85, 1.00) * pow(max(1.0 - length(p - light) * 0.55, 0.0), 2.5) * 0.30;

    float strength = uIntensity * uVisibility * uStrength;
    float alpha = clamp(max(max(color.r, color.g), color.b), 0.0, 1.0);

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(color * strength, alpha * strength);
}
